import { render, staticRenderFns } from "./language-select.vue?vue&type=template&id=10d02572"
import script from "./language-select.vue?vue&type=script&lang=js"
export * from "./language-select.vue?vue&type=script&lang=js"
import style0 from "./language-select.vue?vue&type=style&index=0&id=10d02572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports